import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementCandidateAvailabilityAdded_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementCandidateAvailabilityAdded_ActivityLogFragment;
}

const ActivityLogTaskRequirementCandidateAvailabilityAdded: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.createdAvailabilityRequest"
    />
  );
};

ActivityLogTaskRequirementCandidateAvailabilityAdded.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementCandidateAvailabilityAdded_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementCandidateAvailabilityAdded;
